export const initProfileContact = () => {
  const profileContact = document.getElementById("profile-contact") as HTMLFormElement;

  if (!profileContact) {
    return;
  }

  const viewExamples = profileContact.querySelector(".viewExamples") as HTMLButtonElement;

  const examples = profileContact.querySelector(".examples") as HTMLDivElement;

  viewExamples.addEventListener("click", () => {
    examples.classList.toggle("d-none");

    if (!examples.classList.contains("d-none")) {
      viewExamples.scrollIntoView({ block: "center" });
    }
  });
};
